import { Pipe, PipeTransform } from '@angular/core';
import { TransactionType } from 'common';
import { TransactionData, toPayoffDestinationsText } from './transaction.model';

// Own account first, then the payoff lenders on one line; a Payoff with neither shows '-'.
@Pipe({
    name: 'bankAccountLines',
    standalone: false
})
export class BankAccountLinesPipe implements PipeTransform {

  transform(tx: TransactionData): string[] {
    const lines: string[] = [];
    if (tx.bankAccount) {
      lines.push(tx.bankAccount);
    }
    if (tx.payoffDestinations?.length) {
      lines.push(toPayoffDestinationsText(tx.payoffDestinations));
    }
    if (!lines.length && tx.type === TransactionType.Payoff) {
      lines.push('-');
    }
    return lines;
  }
}
